module.exports = __webpack_public_path__ + "static/img/vip.9c8cea29.webp";